export const getIndex = (key: string) => `${process.env.NEXT_PUBLIC_APP_ENV || 'local'}_${key}`;
